import programReducer from '@/containers/Data-Star/Programs/redux/reducer';
import applicantsReducer from '@/containers/Data-Star/Applicants/redux/reducer';

export const DataStarReducers = {
  programs: programReducer,
  applicants: applicantsReducer,
};
